export const NON_SOURCE_LAYERS = ["background", "raster", "hillshade", "heatmap", "color-relief"];
